export default __webpack_public_path__ + "static/media/Mask Group 11.062f2bf2.png";